export const UPDATE_PREVIEW = 'zola/website/page/UPDATE_PREVIEW';
